import Model, { attr, belongsTo } from '@ember-data/model';

export default class EvisionConfig extends Model {
  @belongsTo('file-retention', { inverse: null, async: false, embedded: true }) fileRetention;
  @belongsTo('naming-convention', { inverse: null, async: false, embedded: true }) namingConvention;
  @attr('number') thumbnailWidth;
  @attr('number') thumbnailHeight;

  get isDirty() {
    return super.isDirty ||
      this.fileRetention.isDirty ||
      this.namingConvention.isDirty;
  }
}
